module.exports = __webpack_public_path__ + "static/media/place_24px_outlined.6b390e9c.svg";